import React from 'react';
import { FileTextIcon, SearchIcon, LayoutIcon, ShoppingBagIcon, BookOpenIcon } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Blog & Article Writing',
    description: 'Engaging, informative blog posts and articles that captivate readers and establish your authority.',
    icon: <FileTextIcon className="h-10 w-10 text-blue-600" data-id="element-143" />
  }, {
    title: 'SEO Content Writing',
    description: 'Strategic content optimized for search engines to improve your visibility and drive organic traffic.',
    icon: <SearchIcon className="h-10 w-10 text-blue-600" data-id="element-144" />
  }, {
    title: 'Website Copywriting',
    description: 'Compelling website copy that clearly communicates your value proposition and converts visitors.',
    icon: <LayoutIcon className="h-10 w-10 text-blue-600" data-id="element-145" />
  }, {
    title: 'Product Descriptions',
    description: 'Persuasive product descriptions that highlight benefits and features to boost sales.',
    icon: <ShoppingBagIcon className="h-10 w-10 text-blue-600" data-id="element-146" />
  }, {
    title: 'Research & Academic Writing',
    description: 'Well-researched, structured academic content that meets scholarly standards.',
    icon: <BookOpenIcon className="h-10 w-10 text-blue-600" data-id="element-147" />
  }];
  return <section id="services" className="py-20 px-4 bg-blue-50" data-id="element-148">
      <div className="max-w-6xl mx-auto" data-id="element-149">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-16" data-id="element-150">
          My Services
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-151">
          {services.map((service, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow border border-blue-100" data-id="element-152">
              <div className="mb-6" data-id="element-153">{service.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-154">
                {service.title}
              </h3>
              <p className="text-gray-600" data-id="element-155">{service.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}